<script>
/* eslint-disabled */

export default {
    props: ['item', 'order'],
    computed: {
        alternateColor(){
            return this.order % 2 == 0
        },
        title(){
            const item = this.item
            if (typeof item.round_counter !== 'undefined') {
                return item.title
            }
            else if (item.type === 'move') {
                return `${item.title}`
            }
            else if (item.type === 'instruction') {
                return item.instruction
            }
            return ''
        },
        notes(){
            const item = this.item
            if (item.type === 'move') {
                return item.instruction
            }
            else if (item.type === 'instruction') {
                return ''
            }
            return ''
        },
        isRoundMarker(){
            return typeof this.item.round_counter !== 'undefined'
        },
        rounds(){
            const rounds = []
            for(let i=0;i<this.item.round_counter;i++) {
                rounds.push(i)
            }
            return rounds
        }
    }
}
</script>


<style scoped>
    .selector{
        border-right: 5px solid #707070;
       padding-top: 8px;
       padding-bottom: 8px;
    }
    .selector .round input[type=checkbox]{
        height: 0;
    }
    .row{
        min-height: 40px;
        margin:-1px 0 0 0;
    }
    .label{
        text-align: right;
        text-transform: uppercase;
    }
    .input-container{
       background-color: #effdff;
    }
    .input-container .group, .input-container .selector{
       padding-top: 8px;
       padding-bottom: 8px;
    }
    .btn-action-group{
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .btn-action-group .btn-action{
        text-transform: uppercase;
        margin-right: 1rem;
        padding: 0.75rem;
    }
    .script-item{
        font-family: 'Times New Roman', Times, serif;
        display: block;
    }
    .script-item.move-block{
        font-size: 24px;
        color: #000;
        font-weight: bold;
    }
    .script-item.move-block.alt{
        color: #34B362;
    }
    .script-item.note-block{
        font-size: 18px;
        color: #F2711C;
    }
    .count{
        margin-right: 1.5rem;
    }   
    .reps-count-mark{
        font-size: 24px;
        font-family: 'Times New Roman', Times, serif;
        font-weight: 600;
    } 
    .label-with-reps{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .reps-box{
        margin-left: 2rem;
    }
    .reps-wrap{
        text-align: right;
    }
    button.icon-only{
        border: 0;
        background-color: transparent;
    }
    .details-wrapper{
        padding-top: 10px;
        padding-bottom: 8px;
    }
</style>
<template>
    <div class="row">
        <div class="selector col-md-1">
        </div>
        <div class="col-md-11">
            <div class="row">
                <div class="col-md-8 col-sm-7">
                    <div class="float-left count">
                        <span class="move-block script-item">{{order}}.</span>
                    </div>
                    <div class="float-left">
                        <span class="move-block script-item" :class="alternateColor ? 'alt' : ''">{{title}}</span>
                        <span class="note-block script-item" v-if="isRoundMarker">
                            <b-icon icon="arrow-right" variant="success" v-for="round in rounds" :key="round"></b-icon>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>